import { Customer } from "@/types/profile";

// Mock customer data - matches database UUIDs
export const mockCustomers: Customer[] = [
  { id: "11111111-1111-1111-1111-111111111111", name: "Acme Corp" },
  { id: "22222222-2222-2222-2222-222222222222", name: "Global Industries" },
  { id: "33333333-3333-3333-3333-333333333333", name: "Stark Enterprises" },
  { id: "44444444-4444-4444-4444-444444444444", name: "Wayne Technologies" },
  { id: "55555555-5555-5555-5555-555555555555", name: "Umbrella Corporation" },
  { id: "66666666-6666-6666-6666-666666666666", name: "Aperture Science" },
  { id: "77777777-7777-7777-7777-777777777777", name: "Cyberdyne Systems" },
  { id: "88888888-8888-8888-8888-888888888888", name: "Massive Dynamics" },
  { id: "99999999-9999-9999-9999-999999999999", name: "Nakatomi Trading" },
  { id: "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa", name: "Initech Software" }
];

// Utility function to get customer name by ID
export const getCustomerName = (customerId: string): string => {
  const customer = mockCustomers.find(c => c.id === customerId);
  return customer?.name || customerId; // Fallback to ID if name not found
};

// Utility function to get customer names for an array of IDs
export const getCustomerNames = (customerIds: string[]): string[] => {
  return customerIds.map(id => getCustomerName(id));
};

// Utility function to get all customers
export const getAllCustomers = (): Customer[] => {
  return mockCustomers;
};